/* eslint-disable  */
import Get from 'lodash/get';
import dayjs from 'dayjs';

export const formatDate = date => {

    if (date) {
        return dayjs(date).format('MM/DD/YYYY').toString();
    }

    return '';

};

export const formatDateForComponent = date => {


    if (date) {
        return dayjs(date).format('YYYY-MM-DD').toString();
    }

    return '';

};

export const formatDatePaidForComponent = date => {

    if (date) {
        return dayjs(date).format('YYYY-MM-DD').toString();
    }

    return dayjs().format('YYYY-MM-DD').toString();

};

export const formatBool = val => {
    if (val === null) return '';

    return val ? 'Yes' : 'No';
};

const getLookUpCode = order => Get(order, 'lookup_code');
export const getUnitType = (order, unitTypeMappings) => {

    // console.log(order)
    // console.log(unitTypeMappings);

    const lookup_code = getLookUpCode(order);
    const unit_space_name = Get(order, 'unit_space_name');

    // console.log(lookup_code, unit_space_name)

    if (lookup_code && unit_space_name) {

        return Get(unitTypeMappings, `${lookup_code}.${unit_space_name}`);
    }
    // console.log(order)
    // console.log('weee')
    return 'N/A';
};

// eslint-disable-next-line arrow-body-style
export const getFloorByUnitSpaceName = unit_space_name => {

    const right_side = unit_space_name.split('-')[1];

    return (right_side.match(/.{1,2}/g) || [])[0];

};

export const getFloorsByBuilding = (data, building) => {

    const filtered_data = data.filter(x => x.building === building);
    const floors = [...new Set(filtered_data.map(x => (x.floor)))];

    return floors;

};

export const countByAmenityBuildingFloor = (data, amenity_name, building, floor) => {

    if (floor) {
        const filtered_data = data.filter(x => x.building === building);

        return filtered_data.length;
    }
    const filtered_data = data.filter(x => x.building === building && x.floor === floor);

    return filtered_data.length;

};

/*Cases:
1)Coming From Entrata (no fields added, so no register on db)
2)Coming From Entrata (with fields added, there is a register on db)
3)Deleted from Entrata but there is a register on DB
3)Custom (inserted on db but not in Entrata)
*/

export const getSource = (order, ordersInEntrata, ordersNotInEntrata) => {

    const findEl = element => (
        element.unit_space_name === order.unit_space_name
        && element.amenity_name === order.amenity_name
    );

    const entrataOrder = ordersInEntrata.find(findEl);
    const maybeCustomOrder = ordersNotInEntrata.find(findEl);

    let isClean = false;

    if (entrataOrder) {

        isClean = (
            entrataOrder.check_number === undefined
            && entrataOrder.date_paid === undefined
            && entrataOrder.manager_notes === undefined
            && entrataOrder.ordered === undefined
            && entrataOrder.owner_notes === undefined
            && entrataOrder.paid === undefined
        );
    }

    const returns = {
        inEntrata: !!entrataOrder,
        isCustom: maybeCustomOrder?.custom,
        isClean
    };

    return returns;

};


export const menu = (value, amenity_types) => {

    const data = [];

    if (!value) {
        return data;
    }

    const type = (amenity_types || []).filter(x => x.tag === value);

    type.map(x => {

        data.push({
            key: x.type,
            value: x.type,
            label: x.type
        });

        return data;
    });

    return data;

};
